// ToastifyComponent.js
import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Toastify = () => {
  return <ToastContainer />;
};

export default Toastify;
